module.exports = __webpack_public_path__ + "static/media/breakdownTable2_mobile.c331401a.png";